module.exports = __webpack_public_path__ + "static/media/z-alpha.383ab16e.png";